import Header from "./Header";
import Footer from "./Footer";
import './PrivacyPolicy.css';
import TermsofUseH2Webp from '../img/TermsofUse-h2.webp';
import TermsofUseH2 from '../img/TermsofUse-h2.png';

export default function Rule() {
    return (
        <div id="top">
            <Header />
            <div className="PrivacyPolicy">
                <div className="PrivacyPolicy__h2 rule">
                    <picture>
                        <source type="image/webp" srcSet={TermsofUseH2Webp} />
                        <img src={TermsofUseH2} alt="Terms of Use" />
                    </picture>
                </div>
                <p>These Terms of Use (hereinafter referred to as “Terms and Conditions”) apply to all those who own BŌSŌ TOKYO NFTs(“NFTs”) by legal means. All persons who own the NFT (“Owner”) shall be governed by these Terms and Conditions that describe the rules regarding the use of the NFTs, the Buyer’s right to claim the NFTs, the conditions and fees associated with claiming the NFTs, and the conditions under which the NFTs will be delivered to the Buyer.</p>

                <h3>1. Conditions of Use</h3>
                <p>
                    a. Owner must be of legal age to form a binding agreement in the country, state or other jurisdiction in which the owner resides.<br />
                    b. Owner must declare that he/she is a citizen or resident of the country or region where BŌSŌ TOKYO provides its services.<br />
                    c. Owner must store the NFT at all times during the mint.<br />
                    d. Owner must agree to these Terms and Conditions.
                </p>

                <h3>2. NFTs Management</h3>
                <p>
                    The Owner is solely responsible for the security of the NFTs belonging to his/her wallet (including the proper management and implementation of relevant security measures).
                </p>

                <h3>3. What-You-Get</h3>
                <p>
                    When you own NFTs, your NFT, an NFT would be attributed to your wallet as a crypto asset (NFT) recorded on the Ethereum network.<br />
                    No ownership or intellectual property rights in the owned NFT artwork will be granted.<br />
                    However, BŌSŌ TOKYO provides the Owner with an uncapped license (“License”) to use the artwork associated with the NFT for commercial purposes in accordance with these Terms and Conditions.
                </p>

                <h3>4. License</h3>
                <p>
                    For each NFT owned, the sole license to use the artwork of one character from the BŌSŌ TOKYO collection (including specific artwork to be subsequently granted to the owner of said NFT) The sole license to use the artwork (including specific artwork subsequently granted to the owner of the NFT in question) is granted. This license is uncapped and there is no limit to the amount of revenue that can be generated from the use of the artwork as long as you remain the owner of the NFT.<br />
                    However, modifications to the artwork (except for making monochrome copies) are not permitted. Modification of artwork is permitted for non-commercial and personal use only.<br />
                    The artwork license is automatically terminated and deemed revoked if the artwork is used for immoral or offensive purposes or in any way that damages the BŌSŌ TOKYO brand or community.<br />
                    BŌSŌ TOKYO reserves the right to use NFT artwork for promotional or non-commercial purposes of BŌSŌ TOKYO.
                </p>

                <h3>5.Transfer of NFT</h3>
                <p>
                    All transfers (including sales) of NFTs shall be subject to these Terms and Conditions. These Terms shall be automatically incorporated into any transfer agreement (verbal and writing) between the current owner (“Seller”) and the new Owner.<br />
                    The License for the artwork is transferred together with the NFT and upon transfer, the Seller shall immediately cease any use (commercial or non-commercial) of the artwork.<br />
                    The Owner also agrees that, if any third party from whom you have purchased the NFT fails to pay any fees owed to BŌSŌ TOKYO in connection with the NFT transfer, BŌSŌ TOKYO may refuse to provide the Owner access until such fee payment has been settled.
                </p>

                <h3>6. Indemnity</h3>
                <p>
                    The Owner agrees to indemnify and hold BŌSŌ TOKYO and its affiliates harmless from any and all claims, demands, liabilities, damages, fines, taxes, costs and expenses (including, without limitation, reasonable legal fees and court costs) arising out of or in connection with (a) the breach of these “Terms and Conditions” or (b) any claim from a third party who fails to meet the terms of this NFT due to the fact that it was acquired from the original Owner.
                </p>

                <h3>7. Disclaimer of Warranties</h3>
                <p>
                    BŌSŌ TOKYO, its contractors, and their respective affiliates provide the NFTs "as is" to "whomever" and explicitly disclaim any representations or warranties of any kind, expressed or implied, including warranties of title, non-infringement, merchantability, fitness for a particular purpose, course of performance, course of dealing, or any trade practices.
                </p>

                <h3>8. Indemnification of Damages</h3>
                <p>
                    In no event shall BŌSŌ TOKYO, its contractors or their respective affiliates be liable for indirect, incidental, and consequential damages or any other non-direct damages or special, punitive or similar damages of any kind.
                </p>

                <h3>9. limitation of liability</h3>
                <p>The maximum aggregate liability of BŌSŌ TOKYO and its contractors and their respective affiliates for all damages and causes of action, whether in contract, tort (including negligence) or otherwise, shall be USD 100.</p>

            </div>
            <Footer />
        </div>
    );
}